import "core-js/modules/es.array.push.js";
import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import pinyin from 'js-pinyin';
import NavBar from "@/view/components/nav-bar/nav-bar.vue";
import RouterUtil from "@/utils/RouterUtil";
import StorageUtil from "@/utils/StorageUtil";
import Config from "@/config";
export default {
  name: "City",
  components: {
    NavBar
  },
  setup() {
    const title = ref("选择城市");
    const map = shallowRef();
    const districtSearch = shallowRef();
    const cityKeyword = ref();
    const filterData = ref();
    const cityData = ref();
    const searchTimeout = ref();
    return {
      title,
      map,
      districtSearch,
      cityKeyword,
      filterData,
      cityData,
      searchTimeout
    };
  },
  mounted() {
    //DOM初始化完成进行地图初始化
    this.initMap();
    // this.pinyin();
  },
  unmounted() {
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        "AMap.Geocoder", "AMap.Geolocation", "AMap.Weather", "AMap.DistrictSearch"]
      }).then(AMap => {
        this.map = new AMap.Map("city-map", {
          //设置地图容器ID
          viewMode: "2D",
          //是否为3D地图模式
          zoom: 16,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",   //地图样式
        });

        // this.geolocation = new AMap.Geolocation({
        //     enableHighAccuracy: true,               //是否使用高精度定位，默认:true
        //     timeout: 10000,                         //超过10秒后停止定位，默认：5s
        //     //position: 'RB',                         //定位按钮的停靠位置
        //     //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
        //     zoomToAccuracy: true,                   //定位成功后是否自动调整地图视野到定位点
        // });
        //
        // this.geocoder = new AMap.Geocoder({
        //     // city: "010",                            //城市设为北京，默认：“全国”
        //     // radius: 1000                            //范围，默认：500
        // });
        //
        // this.weather = new AMap.Weather();

        this.districtSearch = new AMap.DistrictSearch({
          // 关键字对应的行政区级别，country表示国家，province表示省，city表示市
          level: 'city',
          //  显示下级行政区级数，1表示返回下一级行政区
          subdistrict: 3
        });
        this.map.on('moveend', function () {
          that.position = that.map.getCenter();
          if (!that.noQueryAddress) {
            that.getAddress(that.position);
          }
          that.noQueryAddress = false;
        });
        this.getDistrictSearch();
        // this.getAddress(this.position);
      }).catch(e => {
        console.error(e);
      });
    },
    getDistrictSearch() {
      const that = this;
      that.filterData = [];
      clearTimeout(that.searchTimeout);
      that.searchTimeout = setTimeout(function () {
        // 搜索所有省/直辖市信息
        that.districtSearch.search(that.cityKeyword && that.cityKeyword.length > 0 ? that.cityKeyword : "中国", function (status, result) {
          if (status === "complete") {
            console.log(result);
            that.cityData = [];
            const list = result.districtList;
            if (list && list.length && list.length > 0) {
              const data = result.districtList;
              for (let h = 0; h < data.length; h++) {
                const item = data[h];
                if (item.level === "district") {
                  const district = item;
                  if (district.name.indexOf("市") > 0 || district.name.indexOf("县") > 0) {
                    that.cityData.push({
                      id: district.adcode,
                      name: district.name,
                      center: district.center,
                      zoom: 16
                    });
                  }
                }
                if (item.level === "city") {
                  const city = item;
                  if (city.name.indexOf("市") > 0 || city.name.indexOf("县") > 0) {
                    that.cityData.push({
                      id: city.adcode,
                      name: city.name,
                      center: city.center,
                      zoom: 14
                    });
                  }
                  // const districts = city.districtList;
                  // if (districts && districts.length && districts.length > 0) {
                  //   for (let k = 0; k < districts.length; k++) {
                  //     const district = districts[k];
                  //     if (district.name.indexOf("市") > 0
                  //         || district.name.indexOf("县") > 0) {
                  //       that.cityData.push({
                  //         id: district.adcode,
                  //         name: district.name,
                  //         center: district.center,
                  //       });
                  //     }
                  //   }
                  // }
                }
                if (item.level === "province") {
                  const province = item;
                  const citys = province.districtList;
                  if (province.name.indexOf("市") > 0 || province.name.indexOf("县") > 0) {
                    that.cityData.push({
                      id: province.adcode,
                      name: province.name,
                      center: province.center,
                      zoom: 16
                    });
                  }
                  if (citys && citys.length && citys.length > 0) {
                    for (let j = 0; j < citys.length; j++) {
                      const city = citys[j];
                      if (city.name.indexOf("市") > 0 || city.name.indexOf("县") > 0) {
                        that.cityData.push({
                          id: city.adcode,
                          name: city.name,
                          center: city.center,
                          zoom: 14
                        });
                      }
                      const districts = city.districtList;
                      if (districts && districts.length && districts.length > 0) {
                        for (let k = 0; k < districts.length; k++) {
                          const district = districts[k];
                          if (district.name.indexOf("市") > 0 || district.name.indexOf("县") > 0) {
                            that.cityData.push({
                              id: district.adcode,
                              name: district.name,
                              center: district.center,
                              zoom: 16
                            });
                          }
                        }
                      }
                    }
                  }
                }
                if (item.level === "country") {
                  const provinces = item.districtList;
                  if (provinces && provinces.length && provinces.length > 0) {
                    for (let i = 0; i < provinces.length; i++) {
                      const province = provinces[i];
                      const citys = province.districtList;
                      if (province.name.indexOf("市") > 0 || province.name.indexOf("县") > 0) {
                        that.cityData.push({
                          id: province.adcode,
                          name: province.name,
                          center: province.center,
                          zoom: 16
                        });
                      }
                      if (citys && citys.length && citys.length > 0) {
                        for (let j = 0; j < citys.length; j++) {
                          const city = citys[j];
                          if (city.name.indexOf("市") > 0 || city.name.indexOf("县") > 0) {
                            that.cityData.push({
                              id: city.adcode,
                              name: city.name,
                              center: city.center
                            });
                          }
                          const districts = city.districtList;
                          if (districts && districts.length && districts.length > 0) {
                            for (let k = 0; k < districts.length; k++) {
                              const district = districts[k];
                              if (district.name.indexOf("市") > 0 || district.name.indexOf("县") > 0) {
                                that.cityData.push({
                                  id: district.adcode,
                                  name: district.name,
                                  center: district.center
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                that.pinyin();
              }
            }
          }
        });
      }, 500);
    },
    pinyin() {
      this.cityData.map(item => {
        item.pinyin = pinyin.getFullChars(item.name);
      });
      let citys = {};
      this.cityData.map(item => {
        const initials = item.pinyin[0].toUpperCase();
        // 如果对象里有当前字母项则直接 push 一个对象,如果没有则创建一个新的键并赋值;
        if (citys[initials]) {
          citys[initials].push(item);
        } else {
          citys[initials] = [item];
        }
      });
      // 将数据转为数组，并按字母顺利排列
      this.filterData = [];
      for (let key in citys) {
        const obj = {
          letter: key,
          list: citys[key]
        };
        this.filterData.push(obj);
      }
      this.filterData.sort((a, b) => {
        return a.letter.localeCompare(b.letter);
      });
    },
    selectCity(listIndex, itemIndex) {
      const that = this;
      StorageUtil.setObject("cityData", this.filterData[listIndex].list[itemIndex]);
      RouterUtil.back();
    },
    goBack() {
      RouterUtil.back();
    }
  }
};